exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-skeleton-1ghG7{background:linear-gradient(100deg,var(--color-sky-gray2) 8%,#fff 18%,var(--color-sky-gray2) 33%);border-radius:5px;background-size:200% 100%;animation:1.5s linear infinite}@keyframes style-cssmodule-shine-uH6b-{to{background-position-x:-200%}}", ""]);

// exports
exports.locals = {
	"skeleton": "style-cssmodule-skeleton-1ghG7",
	"shine": "style-cssmodule-shine-uH6b-"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./components/skeleton/style.cssmodule.css
// module id = 2539
// module chunks = 121